<template>
  <div class="wan-resources-upload-wrap">
    <!-- *选择档夹类型 -->
    <div class="file-type-wrap">
      <div class="title-wrap">
        <div class="title">*选择档夹类型</div>
        <div v-if="ruleForm.projectType" class="msg">
          {{ fileMsg[ruleForm.projectType].msg }}
        </div>
      </div>

      <el-radio-group v-model="ruleForm.projectType" @change="changeFileType">
        <el-radio v-for="item in fileTypeList" :key="item.id" :label="item.id"
          >{{ item.name }}
        </el-radio>
      </el-radio-group>
    </div>

    <!-- 项目周期 -->
    <div
      v-if="ruleForm.projectType === 'd'"
      class="wan-resources-upload-content"
    >
      <div class="title-wrap">
        <div class="title">*项目周期</div>
      </div>

      <div>
        <el-date-picker
          v-model="ruleForm.projectDate"
          end-placeholder="结束日期"
          range-separator="至"
          start-placeholder="开始日期"
          style="width: 100%"
          type="daterange"
          value-format="yyyy/MM/dd"
        >
        </el-date-picker>
      </div>
    </div>

    <!-- 项目成员 -->
    <div
      v-if="ruleForm.projectType === 'd'"
      class="wan-resources-upload-content"
    >
      <div class="title-wrap" style="margin-bottom: 0">
        <div class="title">项目成员</div>
        <div class="msg">
          已添加{{ memberList.length }}名成员，第1个默认为项目经理
        </div>
        <div class="operation" @click="pickMember">[{{ "选择成员" }}]</div>
      </div>
      <div class="project-members-wrap">
        <div
          v-for="(item, index) in memberList"
          :key="index"
          class="project-members"
        >
          <img :src="item.headerUrl" alt="" class="project-members-avator" />
          <div class="name-pm">{{ item.name }}</div>
          <div class="">{{ item.specialtyName }}</div>
        </div>
      </div>
    </div>

    <!-- **选择档务分类 -->
<!--    <div class="wan-resources-upload-content">
      <div class="title-wrap">
        <div class="title">*选择档务分类</div>
        <div class="msg">分类支持多选</div>
        <div class="operation" @click="pickClassify">
          [{{ drawerParams.drawerType === 1 ? "设置分类" : "修改分类" }}]
        </div>
      </div>

      &lt;!&ndash; 选择分类 &ndash;&gt;
      <div v-if="classifyType" class="classify-add-wrap">
        &lt;!&ndash; 系统分类 &ndash;&gt;
        <div v-for="item in sysClassList" :key="item.id" class="classify-item">
          <div class="title">{{ item.name }}</div>
          <div class="classify-item-checkbox">
            <el-checkbox-group v-model="item.subList">
              <el-checkbox
                v-for="item2 in item.subclassList"
                :key="item2.id"
                :label="item2.id"
                >{{ item2.name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        &lt;!&ndash; 自定义分类 &ndash;&gt;
        <div
          v-for="item in customClassList"
          :key="item.id"
          class="classify-item"
        >
          <div class="title">{{ item.name }}</div>
          <div class="classify-item-checkbox">
            <el-checkbox-group v-model="item.subList">
              <el-checkbox
                v-for="item2 in item.subclassList"
                :key="item2.id"
                :label="item2.id"
                >{{ item2.name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>

      &lt;!&ndash; 确定分类 &ndash;&gt;
      <div v-else class="classify-look-wrap">
        &lt;!&ndash; 选中后的系统分类 &ndash;&gt;
        <div
          v-for="item in checkedSysList"
          :key="item.id"
          class="classify-item"
        >
          <div class="title">{{ item.name }}：</div>
          <div
            v-for="(item2, index2) in item.subList"
            :key="item2.id"
            class="classify-item-checkbox"
          >
            {{ item2.name }}{{ index2 === item.subList.length - 1 ? "" : "，" }}
          </div>
        </div>
        &lt;!&ndash; 选中后的自定义分类 &ndash;&gt;
        <div
          v-for="item in checkedCustomList"
          :key="item.id"
          class="classify-item"
        >
          <div class="title">{{ item.name }}：</div>
          <div
            v-for="(item2, index2) in item.subList"
            :key="item2.id"
            class="classify-item-checkbox"
          >
            {{ item2.name }}{{ index2 === item.subList.length - 1 ? "" : "，" }}
          </div>
        </div>
      </div>
    </div>-->

    <!-- 档夹名称 -->
    <div class="wan-resources-upload-content">
      <div class="title-wrap">
        <div class="title">*档夹名称</div>
        <div class="msg">限24字以内</div>
      </div>

      <el-input
        v-model="ruleForm.caseName"
        maxlength="24"
        placeholder="请输入档夹名称"
        show-word-limit
        type="text"
      >
      </el-input>
    </div>

    <!-- 资源介绍 -->
    <div class="wan-resources-upload-content">
      <div class="title-wrap">
        <div class="title">档夹介绍</div>
        <div class="msg">限240字以内</div>
      </div>

      <el-input
        v-model="ruleForm.caseRemark"
        :rows="6"
        maxlength="240"
        placeholder="请输入档夹介绍"
        show-word-limit
        type="textarea"
      >
      </el-input>
    </div>

    <!-- *添加播放资源 -->
    <div class="wan-resources-upload-content">
      <div class="title-wrap">
        <div class="title">*添加播放资源</div>
        <div class="msg">已添加{{ resourceList.length }}个</div>
        <div class="operation" @click="pickResource">[选择资源]</div>
      </div>

      <div class="res-list">
        <div
          v-for="(item, index) in resourceList"
          :key="index"
          class="res-list-item"
        >
          <div class="title">
            <div v-if="!item.isEdit">
              <span style="color: #acadae">{{ item.fileTypeName }} | </span>
              <span
                :style="{
                  color: activeResIndex === index ? '#409EFF' : '#333',
                }"
              >
                {{ item.resName }}
              </span>
            </div>
            <div v-else>
              <el-input
                ref="titleInput"
                v-model="item.resName"
                :maxlength="24"
                show-word-limit
                style="width: 360px"
                @keyup.enter.native="editTitle(item, index)"
              ></el-input>
            </div>
          </div>

          <div class="operation">
            <span v-if="index !== 0" @click="sort(item, index)">↑ | </span>
            <span
              v-if="drawerParams.drawerType !== 1"
              @click="editTitle(item, index)"
            >
              {{ (!item.isEdit ? "修改标题" : "确定") + " | " }}
            </span>
            <span
              v-if="[85, 119, 120, 122].includes(Number(item.fileType))"
              @click="preview(item, index)"
              >预览 |
            </span>
            <span @click="resourceList.splice(index, 1)">删除</span>
          </div>
        </div>
      </div>
    </div>

<!--    小程序端资源展示方式-->
    <div class="file-type-wrap">
      <div class="title-wrap">
        <div class="title">小程序端资源展示方式</div>
      </div>

      <el-radio-group v-model="ruleForm.showMode" @change="changeFileType">
        <el-radio :label="0">上下列表</el-radio>
        <el-radio :label="1">左右滚动</el-radio>
      </el-radio-group>
    </div>

    <!-- 小程序分享图 -->
    <div class="wan-resources-upload-content">
      <div class="title-wrap">
        <div class="title">小程序分享图</div>
        <div class="msg">
          通过小程序对外转发该资源时使用，建议图片比例为500PX：400PX
        </div>
      </div>

      <!-- 小程序分享图 上传组件-->
      <div class="upload-img-wrap">
        <el-upload
          ref="wx-upload"
          accept="image/*,video/*"
          :auto-upload="false"
          :on-change="changeWXImg"
          :show-file-list="false"
          action=""
          list-type="picture-card"
        >
          <img
            v-if="ruleForm.coverUrl"
            :src="ruleForm.coverUrl"
            alt=""
            class="avatar"
          />
          <div v-else class="upload-plus">上传</div>
        </el-upload>

        <!-- 从空间图库中快速选择 -->
        <div class="space-img-list-wrap">
          <div class="title-wrap">
            <div class="title flex">
              <div
                :class="coverImgTypeIndex === 1 ? 'active' : ''"
                class="title-l"
                @click="selectCoverImgType(1)"
              >
                使用播放资源图
              </div>
              &nbsp;|&nbsp;
              <div
                :class="coverImgTypeIndex === 2 ? 'active' : ''"
                class="title-l"
                @click="selectCoverImgType(2)"
              >
                空间图库快速选择
              </div>
            </div>
            <div class="right">
              <i class="el-icon-arrow-left" @click="changeScrollImg('l')"></i>
              <i class="el-icon-arrow-right" @click="changeScrollImg('r')"></i>
            </div>
          </div>
          <div ref="space-imgs-list" class="space-imgs-list">
            <img
              v-for="item in spaceImagesList"
              :key="item.id"
              :src="item.imageUrl"
              alt=""
              style="width: 150px; height: 120px"
              @click="pickSpaceImg(item)"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 空间展示图 -->
    <div class="wan-resources-upload-content">
      <div class="title-wrap">
        <div class="title">空间展示图</div>
        <div class="msg">小程序中，不同的展示效果需要不同尺寸的效果图</div>
      </div>

      <!-- 空间展示图 上传组件-->
      <div class="upload-space-img-wrap">
        <el-upload
          ref="space-upload"
          accept="image/*"
          :auto-upload="false"
          :on-change="changeSpcaeImg"
          :show-file-list="false"
          :style="{
            width: 384 + 'px',
            height: displayH + 'px',
          }"
          action=""
          list-type="picture-card"
        >
          <img
            v-if="ruleForm.freeCoverUrl"
            :src="ruleForm.freeCoverUrl"
            alt=""
            class="avatar"
          />
          <div v-else class="upload-plus">
            建议图片比例{{ imgSizeW }}：{{ imgSizeH }} 上传
          </div>
        </el-upload>

        <div class="msg">
          <p
            :class="imgSizeIndex === 0 ? 'active' : ''"
            @click="changeImgSize(200, 200, 0)"
          >
            [图标式 200PX*200PX]
          </p>
          <p
            :class="imgSizeIndex === 1 ? 'active' : ''"
            @click="changeImgSize(1280, 720, 1)"
          >
            [单横图/二列图 1280PX*720PX]
          </p>
          <p
            :class="imgSizeIndex === 2 ? 'active' : ''"
            @click="changeImgSize(360, 700, 2)"
          >
            [竖屏滑 360PX*700PX]
          </p>
          <p
            :class="imgSizeIndex === 3 ? 'active' : ''"
            @click="changeImgSize(750, 422, 3)"
          >
            [详情图 750PX*422PX]
          </p>
        </div>
      </div>
    </div>

    <wan-cropper
      ref="wan-cropper"
      :cropper-params="cropperParams"
      @onsubmit="onsubmitCropper"
    ></wan-cropper>

    <wan-drawer
      ref="pickDrawer"
      :drawer-params="{
        ...drawerParams,
        title: pickType === 'member' ? '选择成员' : '选择资源',
      }"
    >
      <!-- 选择人员-->
      <pickMember
        v-if="pickType === 'member'"
        ref="pickMember"
        slot="content"
        :drawer-params="drawerParams"
        :parent-checked-list="memberList"
      ></pickMember>

      <!-- 选择资源-->
      <pickResource
        v-if="pickType === 'resource'"
        ref="pickResource"
        slot="content"
        :drawer-params="drawerParams"
        :visible="drawerParams.drawerVisible"
        :parent-checked-list="resourceList"
      ></pickResource>

      <div slot="footer" class="wan-drawer-footer" style="display: block">
        <div class="wan-drawer-back" style="float: right" @click="onsubmit">
          确定
        </div>
      </div>
    </wan-drawer>
  </div>
</template>

<script>
import wanCropper from "@/components/wan-cropper";
import wanDrawer from "@/components/wan-drawer";
import pickMember from "@/components/wan-create-folder/pickMember";
import pickResource from "@/components/wan-create-folder/pickResource";
import { mapState } from "vuex";

export default {
  name: "wan-resources-upload",

  components: {
    wanCropper,
    wanDrawer,
    pickMember,
    pickResource,
  },

  props: {
    // 分类数据
    classifyList: {
      type: Array,
      default: () => [{}, {}, {}],
    },

    // 弹窗参数
    drawerParams: {
      type: Object,
      default: () => ({}),
    },

    // 编辑数据
    drawerDetails: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    ...mapState(["userInfo"]),
  },

  watch: {
    drawerDetails: {
      handler(n) {
        if (!n || Object.keys(n).length === 0) return;
        // form表单赋值
        this.ruleForm = JSON.parse(JSON.stringify(n));
        // 删除列表上一些没用的字段
        delete this.ruleForm.qrCode;
        delete this.ruleForm.id;

        this.classifyType = this.drawerParams.drawerType === 1;
        // 系统分类赋值
        this.checkedSysList = this.ruleForm.sysCateList
          ? JSON.parse(this.ruleForm.sysCateList)
          : [];
        // 内容分类赋值
        this.checkedCustomList = this.ruleForm.customContentCate
          ? JSON.parse(this.ruleForm.customContentCate)
          : [];
      },
      deep: true,
      immediate: true,
    },
  },

  data() {
    return {
      // 表单数据
      ruleForm: {
        caseName: "",
        projectStartTime: "",
        projectEndTime: "",
        resAscr: "",
        caseRemark: "",
        showMode: 0,
        projectType: "F",
        sysCateList: "",
        customContentCate: "",
        freeCoverUrl: "",
        coverUrl: "",
        screenModel: 0,
        fullScreen: 0,
        projectDate: [],
        memberList: [],
        resourceList: [],
      },
      memberList: [],
      resourceList: [],

      activeResIndex: null,
      fileMsg: {
        F: {
          msg: "集合文档夹：将多个资源组织在一起，形成有播放清单的文件夹",
        },
        d: {
          msg: "项目过程夹：有项目周期和项目成员，并添加项目资源的文件夹",
        },
      },
      pcLimit: "",
      pickType: "",

      // 文件类型
      fileTypeList: [
        { id: "F", name: "集合文档夹" },
        // { id: "d", name: "项目过程夹" },
      ],
      // 文件列表
      fileList: [],

      // 图片剪裁的参数
      cropperParams: {},
      imgType: "",

      // 系统内容分类
      sysClassList: [],
      customClassList: [],
      // 选中的分类数据
      checkedSysList: [],
      checkedCustomList: [],
      classifyType: false,

      // 关联合作
      customerList: [],

      // 空间图库
      spaceImagesList: [],

      // 单横图... 图片尺寸所在index
      imgSizeIndex: 0,
      imgSizeW: 200,
      imgSizeH: 200,
      displayH: 384,
      coverImgTypeIndex: 1,
      file: {},
    };
  },

  async created() {
    this.$bus.emit("closeH5");

    this.$bus.on("submitScreenshot", (url) => {
      this.changeImg({ ...this.file, url }, [], "coverUrl");
    });

    // 获取关联合作
    this.customerList = await this.$utils.getCustomerList();
    // 获取分类
    this.sysClassList = await this.$utils.getSysContentCateList();
    this.customClassList = await this.$utils.getCustomContentCateList();
    // 获取档夹详情
    await this.getCaseDetail();
    // 获取空间图库
    this.getGalleryList();
  },

  methods: {
    // 获取档夹详情
    async getCaseDetail() {
      // 编辑时获取
      console.log(this.drawerParams.drawerType, "this.drawerParams.drawerType");
      if (this.drawerParams.drawerType === 2) {
        this.$store.commit("setLoading", true);
        this.ruleForm = (
          await this.$http.getCaseDetail({
            id: this.drawerParams.id,
          })
        ).data;
        this.$store.commit("setLoading", false);
        console.log(this.ruleForm);

        // 项目周期赋值
        this.ruleForm.projectDate = [
          this.ruleForm.projectStartTime,
          this.ruleForm.projectEndTime,
        ];
        // 分类选择按钮赋值
        this.classifyType = this.drawerParams.drawerType === 1;
        // 系统分类赋值
        this.checkedSysList = this.ruleForm.sysCateList
          ? JSON.parse(this.ruleForm.sysCateList)
          : [];
        // 内容分类赋值
        this.checkedCustomList = this.ruleForm.customContentCate
          ? JSON.parse(this.ruleForm.customContentCate)
          : [];
        // 项目成员赋值
        this.memberList = this.ruleForm.memberList || [];
        // 资源赋值
        this.resourceList = this.ruleForm.resourceList || [];
      }
    },

    async editTitle(item, index) {
      if (this.drawerParams.drawerType === 1) return;
      if (item.isEdit) {
        await this.$http.updaterResName({
          caseId: this.drawerParams.id,
          resourceId: item.id,
          resourceName: item.resName,
        });
      }
      this.$set(item, "isEdit", !item.isEdit);
      this.$nextTick(() => {
        this.$refs.titleInput[index].focus();
      });
    },

    preview(item, index) {
      console.log(item, index);
      this.activeResIndex = index;
      this.$bus.emit("openH5", {
        ...item,
        url: item.resUrl ? item.resUrl : item.fileUrl,
        title: item.resName,
      });
    },

    async sort(item, index) {
      this.resourceList = JSON.parse(
        JSON.stringify(
          await this.$utils.sortTable(this.resourceList, item, index)
        )
      );
      console.log(this.resourceList);
    },

    // 提交
    onsubmit() {
      // pickType === 'member'
      switch (this.pickType) {
        case "member":
          if (!this.$refs.pickMember.checkedList.length)
            return this.$message.warning("请选择成员");
          // eslint-disable-next-line no-case-declarations
          let pickMember = this.$refs.pickMember;
          this.memberList = pickMember.list.filter((item) =>
            pickMember.checkedList.includes(item.id)
          );
          break;

        case "resource":
          if (!this.$refs.pickResource.checkedList.length)
            return this.$message.warning("请选择资源");
          // eslint-disable-next-line no-case-declarations
          let pickResource = this.$refs.pickResource;
          this.resourceList = pickResource.tempList.filter((item) =>
            pickResource.checkedList.includes(item.id)
          );
          this.getGalleryList();
          break;
      }
      this.$refs.pickDrawer.drawerVisible = false;
    },

    // 选择文件类型
    changeFileType(v) {
      console.log(v, "vvv");
      this.pcLimit = this.fileTypeList.filter(
        (item) => item.id === v
      )[0].pcLimit;
      // 切换文件类型清空选择的文件
      // this.fileList = [];
    },

    // 选择成员
    pickMember() {
      this.pickType = "member";
      this.$refs.pickDrawer.drawerVisible = true;
    },

    // 选择资源
    pickResource() {
      this.pickType = "resource";
      this.$refs.pickDrawer.drawerVisible = true;
    },

    // 确定分类or选择分类
    pickClassify() {
      if (this.classifyType) {
        // 确定分类
        let list = [],
          list2 = [];
        // 获取选中的系统分类
        this.sysClassList.forEach((item) => {
          if (item.subList && item.subList.length) {
            let subList = [];
            item.subclassList.forEach((item2) => {
              if (item.subList.indexOf(item2.id) > -1) {
                subList.push({
                  id: item2.id,
                  name: item2.name,
                });
              }
            });
            list.push({
              id: item.id,
              name: item.name,
              subList: subList,
            });
          }
        });
        // 获取选中的自定义分类
        this.customClassList.forEach((item) => {
          if (item.subList && item.subList.length) {
            let subList = [];
            item.subclassList.forEach((item2) => {
              if (item.subList.indexOf(item2.id) > -1) {
                subList.push({
                  id: item2.id,
                  name: item2.name,
                });
              }
            });
            list2.push({
              id: item.id,
              name: item.name,
              subList: subList,
            });
          }
        });

        this.checkedSysList = list;
        this.checkedCustomList = list2;
        this.ruleForm.sysCateList =
          list && list.length ? JSON.stringify(list) : "";
        this.ruleForm.customContentCate =
          list2 && list2.length ? JSON.stringify(list2) : "";
        console.log(list, list2);
      } else {
        // 获取选中的系统分类
        this.sysClassList = this.sysClassList.map((item) => {
          let a = this.checkedSysList.filter((v) => v.id === item.id);
          return {
            ...item,
            subList:
              a.length > 0 && a[0].subList && a[0].subList.length > 0
                ? a[0].subList.map((v) => v.id)
                : [],
          };
        });
        // 获取选中的自定义分类
        this.customClassList = this.customClassList.map((item) => {
          let a = this.checkedCustomList.filter((v) => v.id === item.id);
          return {
            ...item,
            subList:
              a.length > 0 && a[0].subList && a[0].subList.length > 0
                ? a[0].subList.map((v) => v.id)
                : [],
          };
        });
      }

      this.classifyType = !this.classifyType;
    },

    // 空间图库
    getGalleryList() {
      if (this.coverImgTypeIndex === 1) {
        // imageUrl
        console.log(this.resourceList, "resourceList fileUrl ");
        this.spaceImagesList = this.resourceList.map((item) => ({
          imageUrl: item.coverUrl,
        }));
      } else {
        this.$http
          .getGalleryList({
            pageIndex: 1,
            pageSize: 10,
            condition: { spaceId: this.userInfo.id },
          })
          .then(({ data }) => {
            this.spaceImagesList = data.result;
          });
      }
    },

    // 选择空间图库
    pickSpaceImg(item) {
      this.$set(this.ruleForm, "coverUrl", item.imageUrl);
    },

    // change 小程序滚动图
    async changeWXImg(file, fileList) {
      this.file = file;
      console.log(file.raw.type, "文件类型");
      if (file.raw.type.indexOf("video") > -1) {
        this.$bus.emit("openH5", {
          url: file.url,
          title: "拖动视频进度确定截图位置",
          fileType: 85,
          isScreenshot: true,
        });
        return;
        // file.url = await this.$utils.findVideoCover(file.url);
      }
      this.changeImg(file, fileList, "coverUrl");
    },

    // change空间滚动图
    changeSpcaeImg(file, fileList) {
      this.changeImg(file, fileList, "freeCoverUrl");
    },

    // 选择图片打开剪裁
    changeImg(file, fileList, type) {
      console.log(file, fileList, type);
      // 图片赋值
      // this.$set(this.cropperParams, "img", file.url);
      this.imgType = type;
      let fixedNumber = [];
      if (type === "coverUrl") {
        fixedNumber = [500, 400];
      } else {
        console.log(this.imgSizeW, this.imgSizeH);
        fixedNumber = [this.imgSizeW, this.imgSizeH];
      }
      this.cropperParams = { ...file, fixedNumber };
      this.$refs["wan-cropper"].cropperVisible = true;
    },

    // 剪裁保存
    onsubmitCropper({ file, imageUrl }) {
      console.log(file, imageUrl);
      this.ruleForm[this.imgType] = imageUrl;
      this.$set(this.ruleForm, this.imgType, imageUrl);
      this.$set(this.ruleForm, this.imgType + "Raw", file);
    },

    // 滚动小程序图库的图
    changeScrollImg(v) {
      const n = 155;
      this.$refs["space-imgs-list"].scrollLeft =
        this.$refs["space-imgs-list"].scrollLeft + (v === "r" ? +n : -n);
    },

    selectCoverImgType(index) {
      this.coverImgTypeIndex = index;
      this.getGalleryList();
    },

    // 选择不同尺寸类型
    changeImgSize(w, h, index) {
      this.imgSizeW = w;
      this.imgSizeH = h;
      this.imgSizeIndex = index;

      switch (index) {
        case 0:
          this.displayH = 384;
          break;
        case 1:
          this.displayH = 216;
          break;
        case 2:
          this.displayH = 747;
          break;
        case 3:
          this.displayH = 216;
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.res-list {
  .res-list-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    align-items: center;

    .title {
      width: 460px;
    }
  }
}
</style>
